export default __webpack_public_path__ + "static/media/sport-kid.9717f059.jpg";